export const newsList = [
  {
    id: "film-001",
    title: "《星河回声》定档端午：科幻外壳下的一次温柔告别",
    subtitle: "导演林知远谈创作：把离别拍成一场穿越星际的重逢",
    categoryKey: "film",
    categoryName: "影视",
    subType: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20film%20poster%20mood%2C%20deep%20navy%20starry%20sky%20with%20warm%20amber%20nebula%2C%20lone%20silhouette%20looking%20at%20distant%20planet%2C%20artistic%20abstract%20space%20atmosphere%2C%20soft%20glow%2C%20editorial%20key%20art%2C%20high%20detail&width=1200&height=800&seq=xmt-film-001&orientation=landscape",
    summary:
      "本周最受期待的科幻片《星河回声》正式定档，导演林知远用一个关于“告别”的故事，把冷峻的宇宙拍出了难得的温度。",
    content: [
      "经过近两年的后期打磨，《星河回声》终于官宣定档端午。影片讲述一名深空信标维护员在孤独值守中，意外收到来自十年前的一段讯息，由此展开一段跨越星际与时间的寻人之旅。",
      "导演林知远在采访中坦言，这次他最想拍的并不是宏大的宇宙奇观，而是“一个人面对告别时的样子”。“科幻只是外壳，真正想讨论的是，如果我们能对过去的自己说一句话，我们会说什么。”",
      "影片的视觉效果由曾参与多部国际科幻制作的团队操刀，全片超过六成镜头使用实景模型结合虚拟拍摄完成，力求在质感上区别于纯 CG 的冷感。",
      "目前点映场口碑已陆续释出，不少观众表示“在宇宙尺度里被戳中泪点”。如果你是喜欢慢热型科幻与细腻情感表达的观众，这部片值得在大银幕前留出两个小时的完整时间。",
    ],
    author: "小蜜桃影视组",
    publishDate: "2026-10-13T09:30:00",
    views: 48210,
    tags: ["科幻", "定档", "端午档"],
    featured: true,
  },
  {
    id: "film-002",
    title: "年度口碑剧《巷口的春天》收官，小人物的温柔击中观众",
    subtitle: "豆瓣开分 8.9，被赞“今年最治愈的家庭群像”",
    categoryKey: "film",
    categoryName: "影视",
    subType: "电视剧",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20nostalgic%20old%20neighborhood%20alley%20at%20golden%20hour%2C%20soft%20sunlight%20through%20leaves%2C%20cozy%20residential%20buildings%20with%20laundry%20hanging%2C%20gentle%20film%20photography%20tone%2C%20amber%20and%20cream%20palette%2C%20editorial%20still&width=1200&height=800&seq=xmt-film-002&orientation=landscape",
    summary:
      "没有强情节、没有流量明星，《巷口的春天》靠一个个普通人的日常切片，成为今年讨论度最高的家庭剧。",
    content: [
      "《巷口的春天》讲述的是南方老城区一条小巷里三户人家的十二年。剧集以极慢的节奏铺陈，却把邻里之间那些说不出口的关心拍得格外动人。",
      "编剧团队在筹备期走访了多个老社区，剧中大量细节来自真实采访：谁家的晾衣杆会越界，谁总在深夜留一盏灯，谁把邻居的孩子当成自己的孙子带。",
      "收官当晚，相关话题连续登上热搜，许多观众留言说“看完想给家里打个电话”。这种由内容本身激发的情绪共鸣，正是当下剧集市场稀缺的东西。",
      "剧方透露，番外篇正在制作中，将以“一年后的巷口”为主题，为观众补上那份未完的牵挂。",
    ],
    author: "小蜜桃影视组",
    publishDate: "2026-09-25T20:10:00",
    views: 39680,
    tags: ["家庭剧", "口碑", "治愈"],
    featured: false,
  },
  {
    id: "film-003",
    title: "音乐综艺《声浪计划》赛制升级，素人歌手迎来高光时刻",
    subtitle: "盲选改版 + 线下巡演，口碑与收视双丰收",
    categoryKey: "film",
    categoryName: "影视",
    subType: "综艺",
    cover:
      "https://readdy.ai/api/search-image?query=live%20concert%20stage%20with%20warm%20spotlight%20beams%2C%20silhouette%20of%20singer%20holding%20microphone%2C%20crowd%20hands%20in%20dark%2C%20vibrant%20orange%20and%20gold%20lighting%2C%20energetic%20atmosphere%2C%20editorial%20photography&width=1200&height=800&seq=xmt-film-003&orientation=landscape",
    summary:
      "本季《声浪计划》取消导师抢人环节，改为“听众先听歌、后看人”，让素人歌手真正凭声音站上舞台。",
    content: [
      "作为一档主打“听见好声音”的音乐综艺，《声浪计划》本季最大的改变是把评判权交还给听众：在盲选阶段，所有画面都被遮住，观众只凭歌声投票。",
      "赛制升级之后，节目反而涌现出更多有辨识度的素人歌者。有在便利店打工的创作人，也有退休后才开始学唱歌的阿姨，他们的故事让节目多了几分生活的厚。",
      "节目组同步启动了线下巡演计划，把舞台搬到城市的livehouse与广场，让音乐回到最贴近人群的地方。",
      "节目相关歌手的新歌在音乐平台的播放量平均上涨了数倍，“综艺带歌”的良性循环这次真的跑通了。",
    ],
    author: "小蜜桃影视组",
    publishDate: "2026-09-22T14:00:00",
    views: 27340,
    tags: ["音乐综艺", "赛制", "素人"],
    featured: false,
  },
  {
    id: "film-004",
    title: "秋季片单前瞻：这五部中小成本电影值得提前关注",
    subtitle: "没有大制作，却可能是最会讲故事的那一批",
    categoryKey: "film",
    categoryName: "影视",
    subType: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20artistic%20cinema%20concept%2C%20empty%20red%20theater%20seats%20in%20soft%20warm%20light%2C%20film%20reel%20silhouette%2C%20muted%20cream%20and%20rust%20palette%2C%20quiet%20editorial%20atmosphere%2C%20high%20detail&width=1200&height=800&seq=xmt-film-004&orientation=landscape",
    summary:
      "当大制作挤满档期，一批中小成本影片正悄悄积攒口碑。它们或许没有流量，却有最扎实的表达。",
    content: [
      "秋季档向来是文艺片与作者电影的主场。今年这几部作品分别来自不同地区的新锐导演，题材涵盖了返乡、养老、城市漂泊等现实话题。",
      "其中一部以县城为背景的作品，全片使用方言对白，被影展评价为“把中国式亲情拍得毫不煽情”。",
      "对于愿意走进艺术影院的观众来说，这批影片提供的不是视觉奇观，而是一段能被记住的情绪。",
    ],
    author: "小蜜桃影视组",
    publishDate: "2026-09-18T10:20:00",
    views: 18650,
    tags: ["片单", "文艺片", "前瞻"],
    featured: false,
  },
  {
    id: "music-001",
    title: "本周新歌速递：五首循环到停不下来的宝藏单曲",
    subtitle: "从卧室流行到城市民谣，耳朵需要换换口味了",
    categoryKey: "music",
    categoryName: "音乐",
    subType: "流行",
    cover:
      "https://readdy.ai/api/search-image?query=artistic%20music%20concept%20photography%2C%20colorful%20vinyl%20records%20and%20headphones%20on%20soft%20cream%20background%2C%20warm%20sunlight%2C%20pastel%20orange%20and%20green%20accents%2C%20clean%20editorial%20composition%2C%20high%20detail&width=1200&height=800&seq=xmt-music-001&orientation=landscape",
    summary:
      "这一周的新歌有点不一样：五首风格各异的作品，从第一句就抓住你的耳朵。",
    content: [
      "本周新歌整体偏向“减法”：编曲更克制，人声更靠前，听起来反而更松弛。",
      "第一首来自一位独立音乐人的卧室作品，只用吉他和环境音就完成了整首歌，被听众称为“深夜专属”。",
      "另有两首来自说唱与电子领域，一快一慢，形成了很好的节奏对比。",
      "我们把这五首做成了一个连续歌单，适合通勤、加班和睡前放松，建议配上耳机慢慢听。",
    ],
    author: "小蜜桃音乐组",
    publishDate: "2026-10-11T08:00:00",
    views: 42180,
    tags: ["新歌", "歌单", "推荐"],
    featured: true,
  },
  {
    id: "music-002",
    title: "民谣现场回归小酒馆：一场没有荧光棒的夜晚",
    subtitle: "三十人的小场地，唱到最后一首没人愿意走",
    categoryKey: "music",
    categoryName: "音乐",
    subType: "民谣",
    cover:
      "https://readdy.ai/api/search-image?query=intimate%20acoustic%20folk%20live%20venue%20at%20night%2C%20warm%20string%20lights%2C%20wooden%20interior%2C%20musician%20with%20guitar%20on%20small%20stage%2C%20cozy%20amber%20glow%2C%20film%20grain%20editorial%20photography&width=1200&height=800&seq=xmt-music-002&orientation=landscape",
    summary:
      "当演唱会越办越大，一些音乐人选择回到只有几十个人的小酒馆，重新找回面对面唱歌的感觉。",
    content: [
      "这场演出没有大屏幕，没有应援灯光，甚至连正式的舞台都算不上，歌手就坐在离观众两米远的地方。",
      "“我想看看你们的表情。”歌手在开场时说。于是整场演出更像一次围坐聊天，每个人都能听清换气的声音。",
      "最后一首歌结束时已经过了午夜，观众自发地又合唱了一遍副歌，没有人急着离开。",
      "这种小规模现场正在重新流行，它提醒我们：音乐最初的样子，本来就是几个人挤在一起分享一段旋律。",
    ],
    author: "小蜜桃音乐组",
    publishDate: "2026-09-24T22:30:00",
    views: 25870,
    tags: ["民谣", "现场", "小酒馆"],
    featured: false,
  },
  {
    id: "music-003",
    title: "电子音乐正在进入客厅：新专辑《低频温柔》试听手记",
    subtitle: "把舞池的节奏，调成了适合在家听的温度",
    categoryKey: "music",
    categoryName: "音乐",
    subType: "电子",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20electronic%20music%20visual%2C%20soft%20gradient%20waves%20in%20warm%20orange%20and%20mint%20green%2C%20grainy%20texture%2C%20minimal%20geometric%20shapes%2C%20modern%20album%20art%20aesthetic%2C%20high%20detail&width=1200&height=800&seq=xmt-music-003&orientation=landscape",
    summary:
      "一张把电子乐“降速”的专辑，证明了节奏感与舒适度并不冲突。",
    content: [
      "《低频温柔》最特别的地方在于，它保留了电子乐的空间感，却把速度整体放慢，让人可以在沙发上完整听完。",
      "制作人在采访中提到，这张专辑的灵感来自疫情期间在家里跳舞的普通人，“不是派对，是自娱自乐”。",
      "专辑后半段加入了大量环境采样：雨声、水壶声、楼下孩子的笑闹，让音乐突然有了生活的颗粒感。",
    ],
    author: "小蜜桃音乐组",
    publishDate: "2026-09-20T16:40:00",
    views: 19240,
    tags: ["电子", "专辑", "试听"],
    featured: false,
  },
  {
    id: "music-004",
    title: "说唱新人图鉴：五个正在被更多人听见的名字",
    subtitle: "他们的歌里，有城市、有加班，也有不甘心",
    categoryKey: "music",
    categoryName: "音乐",
    subType: "说唱",
    cover:
      "https://readdy.ai/api/search-image?query=urban%20street%20culture%20concept%2C%20graffiti%20wall%20in%20warm%20sunset%20light%2C%20sneakers%20and%20boombox%20silhouette%2C%20orange%20and%20deep%20gray%20palette%2C%20bold%20editorial%20music%20photography%2C%20high%20detail&width=1200&height=800&seq=xmt-music-004&orientation=landscape",
    summary:
      "他们没有大厂牌背书，却在短视频与livehouse里，一点点攒起了真正属于自己的听众。",
    content: [
      "本期我们筛选了五位近半年上升最快的说唱新人，他们的共同点是：歌词足够具体，具体到能看见城市的样子。",
      "有人写凌晨三点的便利店，有人写被退稿的第七次，有人写和父亲那通没打完的电话。",
      "相较技巧的炫技，这一批新人更愿意把真实的生活写进flow里，也让说唱重新有了“讲身边事”的质感。",
    ],
    author: "小蜜桃音乐组",
    publishDate: "2026-09-15T11:10:00",
    views: 22130,
    tags: ["说唱", "新人", "图鉴"],
    featured: false,
  },
  {
    id: "lifestyle-001",
    title: "十分钟搞定一周早餐：打工人的低负担快手食谱",
    subtitle: "不用早起一小时，也能吃得像样",
    categoryKey: "lifestyle",
    categoryName: "生活方式",
    subType: "美食",
    cover:
      "https://readdy.ai/api/search-image?query=clean%20bright%20breakfast%20flatlay%20on%20cream%20marble%20table%2C%20toast%20with%20avocado%20and%20egg%2C%20bowl%20of%20yogurt%20with%20berries%2C%20orange%20juice%2C%20soft%20natural%20morning%20light%2C%20minimal%20editorial%20food%20photography&width=1200&height=800&seq=xmt-life-001&orientation=landscape",
    summary:
      "早餐不是仪式感的考题，而是让自己好好开始一天的理由。这几套快手搭配，十分钟就能完成。",
    content: [
      "我们把一周的早餐拆成了“主食 + 蛋白 + 一点水果”的简单公式，不必精确称重，随手搭配就好。",
      "周一到周五分别是：全麦吐司配煎蛋、希腊酸奶配浆果、隔夜燕麦、饭团配味增汤、以及一份可以提前冷冻的蔬菜蛋饼。",
      "关键在于前一晚花五分钟准备：洗好水果、分好燕麦、把蛋饼煎好冷藏，早上只需加热或组装。",
      "吃一顿不慌不忙的早餐，往往能决定一整天的情绪底色，这件事值得认真对待。",
    ],
    author: "小蜜桃生活组",
    publishDate: "2026-10-08T07:20:00",
    views: 51320,
    tags: ["早餐", "食谱", "快手"],
    featured: true,
  },
  {
    id: "lifestyle-002",
    title: "周末短途计划：三小时车程内的五个安静小城",
    subtitle: "不用请假、不用赶路，也能换个心情",
    categoryKey: "lifestyle",
    categoryName: "生活方式",
    subType: "旅行",
    cover:
      "https://readdy.ai/api/search-image?query=serene%20small%20town%20by%20the%20water%20at%20dusk%2C%20old%20stone%20bridge%2C%20warm%20lit%20windows%2C%20soft%20mountain%20silhouette%2C%20calm%20editorial%20travel%20photography%2C%20amber%20and%20sage%20palette%2C%20high%20detail&width=1200&height=800&seq=xmt-life-002&orientation=landscape",
    summary:
      "旅行不一定要远。这三个小时内能到达的小城，安静、干净，适合把手机调成静音。",
    content: [
      "我们按照“交通三小时内、人少、有老街或水边”三个标准，挑出了五个适合周末两日游的小城。",
      "它们大多保留了原生的生活节奏，清晨有菜市场，傍晚有小广场，晚上八点后街上就安静了下来。",
      "建议的玩法是：白天漫无目的地走，找一家本地人常去的小馆子，晚上早点回住处看一部电影。",
    ],
    author: "小蜜桃生活组",
    publishDate: "2026-09-26T18:00:00",
    views: 33760,
    tags: ["旅行", "短途", "周末"],
    featured: false,
  },
  {
    id: "lifestyle-003",
    title: "出租屋改造记：不砸墙也能住得有质感",
    subtitle: "布艺、灯光、收纳，三件小事改变一个家",
    categoryKey: "lifestyle",
    categoryName: "生活方式",
    subType: "家居",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20small%20apartment%20interior%20with%20warm%20lighting%2C%20linen%20curtains%2C%20wooden%20shelves%20with%20books%20and%20plants%2C%20soft%20rug%2C%20cream%20and%20terracotta%20palette%2C%20minimal%20nordic%20style%2C%20editorial%20interior%20photography&width=1200&height=800&seq=xmt-life-003&orientation=landscape",
    summary:
      "房子是租来的，生活不是。用最低成本的方式，让出租屋也能拥有让人想回家的氛围。",
    content: [
      "改造出租屋的第一原则是“可逆”：所有改动都能在搬走时轻松复原，不损坏房东的墙面和地板。",
      "第一步是灯光。把刺眼的白炽灯换成暖光灯泡，再添一盏落地灯或小夜灯，空间立刻柔和下来。",
      "第二步是布艺。一块地毯、一套素色窗帘和几条抱枕套，就能覆盖掉大部分“临时感”。",
      "第三步是收纳。把杂物收进统一的收纳盒，桌面留白，房间的呼吸感就出来了。",
    ],
    author: "小蜜桃生活组",
    publishDate: "2026-09-21T20:30:00",
    views: 28940,
    tags: ["家居", "出租屋", "改造"],
    featured: false,
  },
  {
    id: "lifestyle-004",
    title: "每天二十分钟：新手也能坚持下来的居家运动",
    subtitle: "不比强度，比能不能一直做下去",
    categoryKey: "lifestyle",
    categoryName: "生活方式",
    subType: "健身",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20home%20workout%20scene%2C%20yoga%20mat%20on%20light%20wood%20floor%2C%20water%20bottle%20and%20towel%2C%20soft%20morning%20light%20through%20window%2C%20clean%20cream%20and%20sage%20palette%2C%20calm%20editorial%20photography&width=1200&height=800&seq=xmt-life-004&orientation=landscape",
    summary:
      "健身最难的从来不是动作，而是开始和坚持。把门槛降到二十分钟，反而更容易养成习惯。",
    content: [
      "很多新手健身失败，不是因为不够努力，而是计划太满。与其一周练五次，不如先稳定地做二十分钟。",
      "推荐的动作组合是：五分钟动态热身 + 十分钟自重训练 + 五分钟拉伸，几乎不需要器械。",
      "把运动时间固定在一天中的某个节点（比如晚饭前），比“有空就练”更容易形成惯性。",
      "记录比打卡重要，用手机简单记下每次的感受，几周后回看，你会惊讶于自己的变化。",
    ],
    author: "小蜜桃生活组",
    publishDate: "2026-09-17T09:00:00",
    views: 24510,
    tags: ["健身", "居家", "新手"],
    featured: false,
  },
  {
    id: "brand-001",
    title: "小蜜桃品牌焕新：一抹橙红，是我们想传递的活力",
    subtitle: "从内容栏目到视觉语言，一次关于“亲切感”的升级",
    categoryKey: "brand",
    categoryName: "品牌",
    subType: "品牌故事",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20brand%20identity%20concept%2C%20bold%20orange%20red%20gradient%20shapes%20with%20soft%20peach%20tones%2C%20minimal%20geometric%20composition%20on%20cream%20background%2C%20creative%20studio%20aesthetic%2C%20clean%20editorial%20design&width=1200&height=800&seq=xmt-brand-001&orientation=landscape",
    summary:
      "品牌的每一次改变，都应该回答一个问题：我们想让用户感受到什么。对小蜜桃来说，答案是“轻松和亲切”。",
    content: [
      "小蜜桃不是一个严肃的资讯机器，而更像一个爱聊天的朋友。这一定位决定了我们的视觉语言：明亮、圆润、有温度。",
      "主色调选择了充满活力的橙红，既呼应“蜜桃”的名字，也传递出娱乐内容特有的轻快节奏。",
      "辅以青春绿作为点缀，以及柔和的米白底色，让长时间浏览也不容易疲劳。",
      "未来，我们会在内容、栏目与品牌合作上持续打磨，让“小蜜桃”成为一个让人愿意常回来看看的地方。",
    ],
    author: "小蜜桃品牌组",
    publishDate: "2026-10-05T10:00:00",
    views: 36210,
    tags: ["品牌焕新", "视觉", "定位"],
    featured: true,
  },
  {
    id: "brand-002",
    title: "合作案例：小蜜桃 × 城市青年音乐节",
    subtitle: "内容、线下与用户的一次三方共振",
    categoryKey: "brand",
    categoryName: "品牌",
    subType: "合作案例",
    cover:
      "https://readdy.ai/api/search-image?query=music%20festival%20collaboration%20concept%2C%20crowd%20silhouettes%20at%20sunset%20stage%2C%20warm%20orange%20lighting%20beams%2C%20abstract%20brand%20graphic%20overlay%2C%20energetic%20editorial%20poster%20aesthetic%2C%20high%20detail&width=1200&height=800&seq=xmt-brand-002&orientation=landscape",
    summary:
      "如何让一场音乐节不只是现场的热闹，而是能被持续讨论？我们和主办方一起做了三件事。",
    content: [
      "第一步是内容前置：在音乐节开始前一个月，我们推出了系列探访内容，介绍参演音乐人与城市故事。",
      "第二步是现场共创：小蜜桃在现场设置了内容互动区，观众可以留下自己的“本场最爱一首歌”。",
      "第三步是长尾运营：音乐节结束后，我们把现场的素材整理成回顾专题，让热度延续了整整两周。",
      "最终这场合作的线上曝光量超出预期，也验证了“内容 + 线下”组合的价值。",
    ],
    author: "小蜜桃品牌组",
    publishDate: "2026-09-23T15:30:00",
    views: 21870,
    tags: ["合作案例", "音乐节", "品牌"],
    featured: false,
  },
  {
    id: "brand-003",
    title: "新品发布：小蜜桃 App 全新版本，浏览更快、收藏更顺手",
    subtitle: "这次我们把“找内容”这件事做得更简单了",
    categoryKey: "brand",
    categoryName: "品牌",
    subType: "新品发布",
    cover:
      "https://readdy.ai/api/search-image?query=app%20interface%20product%20mockup%20concept%2C%20warm%20orange%20ui%20cards%20floating%20on%20cream%20background%2C%20soft%20shadows%2C%20minimal%20modern%20tech%20aesthetic%2C%20clean%20editorial%20presentation&width=1200&height=800&seq=xmt-brand-003&orientation=landscape",
    summary:
      "新版本围绕“更快找到想看的内容”重新梳理了信息架构，同时上线了跨设备的收藏同步。",
    content: [
      "新版本最大的变化在首页：我们把最新的内容更早地呈现给用户，减少了滑动寻找的成本。",
      "搜索功能也得到了加强，现在支持按分类范围筛选，找影视资讯时不会再被其他内容打扰。",
      "收藏功能支持跨设备同步，你在手机上看一半的文章，回到家打开电脑可以继续读完。",
    ],
    author: "小蜜桃品牌组",
    publishDate: "2026-09-19T12:00:00",
    views: 17640,
    tags: ["新品", "App", "发布"],
    featured: false,
  },
  {
    id: "brand-004",
    title: "让小蜜桃的内容被更多人看见：我们的内容合作计划",
    subtitle: "面向创作者、品牌与机构的三类合作方向",
    categoryKey: "brand",
    categoryName: "品牌",
    subType: "合作案例",
    cover:
      "https://readdy.ai/api/search-image?query=creative%20team%20collaboration%20concept%2C%20hands%20around%20a%20table%20with%20colorful%20notes%20and%20laptops%2C%20warm%20orange%20accents%2C%20bright%20modern%20workspace%2C%20editorial%20business%20photography&width=1200&height=800&seq=xmt-brand-004&orientation=landscape",
    summary:
      "无论你是创作者、品牌还是机构，只要内容足够真诚，我们都愿意一起把它做出来。",
    content: [
      "第一类是内容共创：我们欢迎创作者投稿或与我们联合策划专栏，题材不限，但要求真实、有观点。",
      "第二类是品牌合作：为品牌提供内容策划、专题制作与整合传播服务，帮助品牌讲好自己的故事。",
      "第三类是机构合作：与媒体、平台、线下空间一起探索更多内容落地的可能性。",
      "如果你感兴趣，可以在品牌服务页填写咨询表单，我们会尽快与你联系。",
    ],
    author: "小蜜桃品牌组",
    publishDate: "2026-09-16T14:20:00",
    views: 15230,
    tags: ["合作", "创作者", "计划"],
    featured: false,
  },
];